import { FormikValues, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

import Ajuda from './Ajuda';

interface Props {
  ajuda?: string;
  name: string;
  rotulo?: string;
  semMargem?: boolean;
  value?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forcarValor?: any;
  desabilitarAoForcar?: boolean;
}

const Radio = (props: Props): React.ReactElement => {
  const [desabilitado, setDesabilitado] = useState<boolean>(false);
  const {
    ajuda,
    name,
    rotulo,
    semMargem,
    forcarValor,
    desabilitarAoForcar = true,
    value,
  } = props;
  const {
    setFieldValue,
    setFieldTouched,
    values,
    getFieldMeta,
    handleBlur,
    handleChange,
    submitCount,
  } = useFormikContext<FormikValues>();
  const { error, touched, value: metaValue } = getFieldMeta(name);

  useEffect(() => {
    if (forcarValor && !values[name]) {
      setFieldValue(name, forcarValor, true);

      if (desabilitarAoForcar) {
        setDesabilitado(true);
      }
    }
  }, [desabilitarAoForcar, name, forcarValor, setFieldValue, values]);

  useEffect(() => {
    if (submitCount && error && !touched) {
      setFieldTouched(name, true, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);

  return (
    <div className={!semMargem ? 'mb-3' : ''}>
      <div className="form-check">
        <input
          type="radio"
          name={name}
          className={`form-check-input ${error && touched && 'is-invalid'}`}
          onChange={handleChange}
          onBlur={handleBlur}
          onSubmit={() => setFieldTouched(name, true, true)}
          value={value}
          {...(metaValue === value && { checked: true })}
          {...(desabilitado ? { disabled: true } : {})}
        />
        <label className="form-check-label" htmlFor={name}>
          {rotulo}
        </label>
        <div className="invalid-feedback">{error && touched && error}</div>
      </div>
      <React.Fragment>{ajuda && <Ajuda>{ajuda}</Ajuda>}</React.Fragment>
    </div>
  );
};

export default Radio;
